import moment from "moment";

export default function (date, format = "YYYY-MM-DD HH:mm:ss") {
    return date ? moment.utc(date).local().format(format) : null;
};
